import { sygnet } from './sygnet';
import { logo } from './logo';
import { logoNegative } from './logo-negative';

import {
    cibSkype,
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cibPaypal,
    cibGooglePay,
    cibCcAmex,
} from '@coreui/icons';
import { cifUs, cifBr, cifIn, cifFr, cifEs, cifPl } from '@coreui/icons';
import {
    cilAccountLogout,
    cilAlignCenter,
    cilAlignLeft,
    cilAlignRight,
    cilApplicationsSettings,
    cilArrowBottom,
    cilArrowLeft,
    cilArrowRight,
    cilArrowThickToBottom,
    cilArrowTop,
    cilAsterisk,
    cilBan,
    cilBasket,
    cilBell,
    cilBold,
    cilBook,
    cilBookmark,
    cilBuilding,
    cilCalculator,
    cilCalendar,
    cilCalendarCheck,
    cilCloudDownload,
    cilChart,
    cilChartLine,
    cilChartPie,
    cilChatBubble,
    cilCheck,
    cilCheckAlt,
    cilChevronBottom,
    cilChevronLeft,
    cilChevronRight,
    cilChevronTop,
    cilCircle,
    cilCheckCircle,
    cilCode,
    cilCog,
    cilCommentSquare,
    cilCreditCard,
    cilCursor,
    cilCursorMove,
    cilDelete,
    cilDescription,
    cilDrop,
    cilEducation,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeLetter,
    cilEnvelopeOpen,
    cilEuro,
    cilExpandDown,
    cilExternalLink,
    cilGift,
    cilGlobeAlt,
    cilGrain,
    cilGrid,
    cilGroup,
    cilFile,
    cilFullscreen,
    cilFullscreenExit,
    cilGraph,
    cilHeart,
    cilHome,
    cilInbox,
    cilIndentDecrease,
    cilIndentIncrease,
    cilInfo,
    cilInputPower,
    cilItalic,
    cilJustifyCenter,
    cilJustifyLeft,
    cilLaptop,
    cilLayers,
    cilLevelDown,
    cilLifeRing,
    cilLightbulb,
    cilList,
    cilListNumbered,
    cilListRich,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMap,
    cilMoon,
    cilMusicNote,
    cilNewspaper,
    cilNotes,
    cilOptions,
    cilPaperclip,
    cilPaperPlane,
    cilPen,
    cilPencil,
    cilPeople,
    cilPhone,
    cilPrint,
    cilPuzzle,
    cilRss,
    cilSave,
    cilSchool,
    cilScrubber,
    cilSend,
    cilSettings,
    cilSitemap,
    cilSmilePlus,
    cilShare,
    cilShareAll,
    cilShareAlt,
    cilShareBoxed,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilSun,
    cilTags,
    cilTask,
    cilTrash,
    cilUnderline,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilUserPlus,
    cilUserUnfollow,
    cilUserX,
    cilVoiceOverRecord,
    cilX,
    cilXCircle,
    cilWarning,
} from '@coreui/icons';

export const icons = Object.assign(
    {},
    {
        sygnet,
        logo,
        logoNegative,
    },
    {
        cilAccountLogout,
        cilAlignCenter,
        cilAlignLeft,
        cilAlignRight,
        cilApplicationsSettings,
        cilArrowBottom,
        cilArrowLeft,
        cilArrowRight,
        cilArrowThickToBottom,
        cilArrowTop,
        cilAsterisk,
        cilBan,
        cilBasket,
        cilBell,
        cilBold,
        cilBook,
        cilBookmark,
        cilBuilding,
        cilCalculator,
        cilCalendar,
        cilCalendarCheck,
        cilCloudDownload,
        cilChart,
        cilChartLine,
        cilChartPie,
        cilChatBubble,
        cilCheck,
        cilCheckAlt,
        cilChevronBottom,
        cilChevronLeft,
        cilChevronRight,
        cilChevronTop,
        cilCircle,
        cilCheckCircle,
        cilCode,
        cilCog,
        cilCommentSquare,
        cilCreditCard,
        cilCursor,
        cilCursorMove,
        cilDelete,
        cilDescription,
        cilDrop,
        cilEducation,
        cilDollar,
        cilEnvelopeClosed,
        cilEnvelopeLetter,
        cilEnvelopeOpen,
        cilEuro,
        cilExpandDown,
        cilExternalLink,
        cilGift,
        cilGlobeAlt,
        cilGrain,
        cilGrid,
        cilGroup,
        cilFile,
        cilFullscreen,
        cilFullscreenExit,
        cilGraph,
        cilHeart,
        cilHome,
        cilInbox,
        cilIndentDecrease,
        cilIndentIncrease,
        cilInfo,
        cilInputPower,
        cilItalic,
        cilJustifyCenter,
        cilJustifyLeft,
        cilLaptop,
        cilLayers,
        cilLevelDown,
        cilLifeRing,
        cilLightbulb,
        cilList,
        cilListNumbered,
        cilListRich,
        cilLocationPin,
        cilLockLocked,
        cilMagnifyingGlass,
        cilMap,
        cilMoon,
        cilMusicNote,
        cilNewspaper,
        cilNotes,
        cilOptions,
        cilPaperclip,
        cilPaperPlane,
        cilPen,
        cilPencil,
        cilPeople,
        cilPhone,
        cilPrint,
        cilPuzzle,
        cilRss,
        cilSave,
        cilSchool,
        cilScrubber,
        cilSend,
        cilSettings,
        cilSitemap,
        cilSmilePlus,
        cilShare,
        cilShareAll,
        cilShareAlt,
        cilShareBoxed,
        cilShieldAlt,
        cilSpeech,
        cilSpeedometer,
        cilSpreadsheet,
        cilStar,
        cilSun,
        cilTags,
        cilTask,
        cilTrash,
        cilUnderline,
        cilUser,
        cilUserFemale,
        cilUserFollow,
        cilUserPlus,
        cilUserUnfollow,
        cilUserX,
        cilVoiceOverRecord,
        cilX,
        cilXCircle,
        cilWarning,
    },
    {
        cifUs,
        cifBr,
        cifIn,
        cifFr,
        cifEs,
        cifPl,
    },
    {
        cibSkype,
        cibFacebook,
        cibTwitter,
        cibLinkedin,
        cibFlickr,
        cibTumblr,
        cibXing,
        cibGithub,
        cibStackoverflow,
        cibYoutube,
        cibDribbble,
        cibInstagram,
        cibPinterest,
        cibVk,
        cibYahoo,
        cibBehance,
        cibReddit,
        cibVimeo,
        cibCcMastercard,
        cibCcVisa,
        cibStripe,
        cibPaypal,
        cibGooglePay,
        cibCcAmex,
    },
);
